<template>
	<div>
		<v-row>
			<tile-container
				v-for="community in communities"
				:key="community.id"
				:size="communityTile.size"
			>
				<component :is="communityTile.component" :community="community" />
			</tile-container>

			<tile-container
				v-for="system in systems"
				:key="system.id"
				:size="systemTile.size"
			>
				<component :is="systemTile.component" :system="system" />
			</tile-container>

			<tile-container :size="userPreviewTile.size" :loading="loading">
				<component :is="userPreviewTile.component" v-if="user" :user="user" />
			</tile-container>

			<tile-container
				v-for="lifecircle in lifecircles.items"
				:key="lifecircle.id"
				:size="communityUsersTile.size"
				:loading="lifecircles.loading"
			>
				<component
					:is="communityUsersTile.component"
					:users="lifecircle.items"
					:show-user-relation="true"
					title="Family"
					user-type="Guests"
				/>
			</tile-container>
		</v-row>
	</div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import api from "@/api/cloud";
import { createUser } from "@/store/model/user";

import TileContainer from "./shared/TileContainer";
import {
	systemTile,
	userPreviewTile,
	communityUsersTile,
	communityTile,
} from "./tiles";

const data = () => ({
	systemTile,
	userPreviewTile,
	communityUsersTile,
	communityTile,

	loading: false,
	user: null,

	lifecircles: {
		loading: false,
		items: [],
	},
});

export default {
	components: { TileContainer },

	data,

	computed: {
		...mapGetters({ system: "session/system" }),

		userId() {
			return this.$route.params.userId;
		},

		systems() {
			return _.get(this.user, "systems", []);
		},

		communities() {
			const associations = _.get(this.user, "associations", []);
			return _.filter(associations, { type: "community" });
		},
	},

	watch: {
		userId() {
			console.debug("User ID changed, reload user");
			this.reloadUser();
		},
	},

	beforeMount() {
		this.reloadUser();
	},

	methods: {
		async reloadUser() {
			Object.assign(this, data());

			this.loading = true;
			try {
				const apiUser = await api.getUser(this.userId);
				this.user = createUser(apiUser);
			} finally {
				this.loading = false;
			}

			this.lifecircles.items = _.map(this.user.lifecircles, circle => ({
				...circle,
				items: [],
			}));
			this.lifecircles.loading = true;
			try {
				for (const lifecircle of this.lifecircles.items) {
					api
						.getAssociationUsers(lifecircle.id, { type: "all" })
						.then(members => {
							lifecircle.items = _.chain(members)
								.map(createUser)
								// Remove ourselves from the list
								.reject(user => user.guid === this.userId)
								.value();
						});
				}
			} finally {
				this.lifecircles.loading = false;
			}
		},

		async loadGuests() {},
	},
};
</script>
